export default [
    {
      title: 'Friend Referral',
      customIcon: 'FriendSVG',
      children: [
        {
          title: 'Activity details',
          route: 'custom-module',
          path: '/custom-module/friend',
        },
      ],
    },
  ];
  